import { base64ToBytes, bytesToBase64 } from './cipher';

/* eslint-disable no-bitwise */
function buildBundleSecret(): Uint8Array {
    const a = new Uint8Array([0xa3, 0x8e, 0xc4, 0x12, 0x57, 0x9b, 0x10, 0xdf]);
    const b = Uint8Array.from(
        atob('Z7Wq3lT6').split('').map((ch) => ch.charCodeAt(0) & 0xff),
    );
    const c = 'PkQz9yMt'.split('').map((ch) => (ch.charCodeAt(0) ^ 0x2a) & 0xff);
    const d = [0x71, 0xc8, 0x33, 0xae, 0x05, 0x9f, 0x6c, 0x12];
    const out = new Uint8Array(32);
    out.set(a, 0);
    out.set(b.subarray(0, 8), 8);
    out.set(Uint8Array.from(c).subarray(0, 8), 16);
    out.set(Uint8Array.from(d), 24);
    return out;
}
/* eslint-enable no-bitwise */

export interface FingerprintInputs {
    title: string;
    lead: string;
    locatorType: string;
    lang: string;
}

const SEP = '\x1f';

export function serializeFingerprint(inputs: FingerprintInputs): string {
    return [
        inputs.title || '',
        inputs.lead || '',
        inputs.locatorType || '',
        inputs.lang || '',
    ].join(SEP);
}

async function hmacSha256(secret: Uint8Array, message: string): Promise<Uint8Array> {
    const cryptoKey = await globalThis.crypto.subtle.importKey(
        'raw',
        secret,
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign'],
    );
    const sig = await globalThis.crypto.subtle.sign(
        'HMAC',
        cryptoKey,
        new TextEncoder().encode(message),
    );
    return new Uint8Array(sig);
}

function buildMask(fingerprint: string): Promise<Uint8Array> {
    return hmacSha256(buildBundleSecret(), fingerprint);
}

function xor(a: Uint8Array, b: Uint8Array): Uint8Array {
    const out = new Uint8Array(a.length);
    for (let i = 0; i < a.length; i += 1) {
        // eslint-disable-next-line no-bitwise
        out[i] = a[i] ^ b[i % b.length];
    }
    return out;
}

export async function packKey(rawKey: Uint8Array, fingerprint: string): Promise<string> {
    const mask = await buildMask(fingerprint);
    return bytesToBase64(xor(rawKey, mask));
}

export async function unpackKey(carrier: string, fingerprint: string): Promise<Uint8Array> {
    const mask = await buildMask(fingerprint);
    return xor(base64ToBytes(carrier), mask);
}
